
import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram } from 'lucide-react';
import { OFFICIAL_INSTAGRAM_URL, SOCIAL_LINKS } from '@/config/siteOrganization';
import InstagramFeed from './InstagramFeed';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-8 sm:py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <InstagramFeed />
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 sm:gap-8">
          <div>
            <img 
              src="/images/995a9d39fcc556866eb42c83f07dbc9c.png" 
              alt="Social Trip" 
              className="h-12 mb-4"
            />
            <p className="text-gray-300 text-sm leading-relaxed">
              あなたの旅行スタイルを分析し、最適な旅行プランを提案するAIサービスです。
            </p>
          </div>
          
          <div>
            <h3 className="font-semibold mb-4">サービス</h3>
            <ul className="space-y-2 text-sm">
              {/* <li>
                <Link to="/diagnosis" className="text-gray-300 hover:text-white transition-colors">
                  旅行タイプ診断
                </Link>
              </li> */}
              <li>
                <Link to="/articles" className="text-gray-300 hover:text-white transition-colors">
                  旅行記事
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-semibold mb-4">サポート</h3>
            <ul className="space-y-2 text-sm">
              {/* よくある質問は非表示 */}
              <li><Link to="/contact" className="text-gray-300 hover:text-white transition-colors">お問い合わせ</Link></li>
              <li><Link to="/terms" className="text-gray-300 hover:text-white transition-colors">利用規約</Link></li>
              <li><Link to="/privacy" className="text-gray-300 hover:text-white transition-colors">プライバシーポリシー</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-semibold mb-4">フォローする</h3>
            {/* URL未設定の SNS は href="#" にしない（クリックでページ先頭へ戻るため非表示） */}
            <a
              href={SOCIAL_LINKS.instagram || OFFICIAL_INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex w-full sm:w-auto items-center justify-center gap-3 rounded-xl border border-pink-400/60 bg-gradient-to-r from-pink-500 to-orange-400 px-4 py-3 sm:px-5 sm:py-3.5 text-white font-medium shadow-md hover:brightness-110 transition-all min-h-12"
              aria-label="Social Trip 公式 Instagram（新しいタブで開く）"
            >
              <Instagram className="w-5 h-5 shrink-0" aria-hidden />
              <span className="text-sm sm:text-base leading-tight text-left">
                <span className="md:hidden">Instagram 公式アカウント</span>
                <span className="hidden md:flex md:flex-col md:leading-snug">
                  <span>Instagram</span>
                  <span>公式アカウント</span>
                </span>
              </span>
            </a>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-6 sm:mt-8 pt-6 sm:pt-8 text-center">
          <p className="text-gray-400 text-xs sm:text-sm px-4">
            © 2024 Social Trip. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
